import ModalManagedAlerts from "./ModalManagedAlerts";

export default ModalManagedAlerts;